// Team page content + member data
// Photos are placeholders — to be replaced by actual portraits provided by the client.

export const teamContent = {
  fr: {
    eyebrow: 'Notre équipe',
    title: "L'équipe du Business Club",
    subtitle:
      "Une équipe complémentaire qui œuvre au développement des relations économiques entre la France et la Lettonie.",
    ctaBack: "Retour à l'accueil",
    boardTitle: 'Vous voulez être candidat au board ?',
    boardSubtitle:
      "Le Business Club France–Latvia accueille les candidatures de profils engagés souhaitant rejoindre son board. Soumettez votre intérêt via le formulaire ci-dessous.",
    members: [
      {
        id: 'william',
        name: 'William Le Clere',
        role: 'Logistics',
        email: 'william@bcfl.eu',
      },
      {
        id: 'eric',
        name: 'Eric Brisset',
        role: 'Investor / Tech',
        email: 'eric@bcfl.eu',
      },
      {
        id: 'inese',
        name: 'Inese Treilina-Bergmane',
        role: 'Real Estate',
        email: 'inese@bcfl.eu',
      },
      {
        id: 'guna',
        name: 'Guna Zagorska',
        role: 'Banking / Finance / Education',
        email: 'guna.zagorska@bcfl.eu',
      },
    ],
  },

  en: {
    eyebrow: 'Our team',
    title: 'The Business Club team',
    subtitle:
      'A complementary team working to develop economic relations between France and Latvia.',
    ctaBack: 'Back to home',
    boardTitle: 'Would you like to apply to the board?',
    boardSubtitle:
      'The Business Club France–Latvia welcomes applications from engaged profiles wishing to join its board. Submit your interest via the form below.',
    members: [
      { id: 'william', name: 'William Le Clere', role: 'Logistics', email: 'william@bcfl.eu' },
      { id: 'eric', name: 'Eric Brisset', role: 'Investor / Tech', email: 'eric@bcfl.eu' },
      { id: 'inese', name: 'Inese Treilina-Bergmane', role: 'Real Estate', email: 'inese@bcfl.eu' },
      { id: 'guna', name: 'Guna Zagorska', role: 'Banking / Finance / Education', email: 'guna.zagorska@bcfl.eu' },
    ],
  },

  lv: {
    eyebrow: 'Mūsu komanda',
    title: 'Biznesa kluba komanda',
    subtitle:
      'Papildinoša komanda, kas darbojas, lai attīstītu ekonomiskās attiecības starp Franciju un Latviju.',
    ctaBack: 'Atpakaļ uz sākumu',
    boardTitle: 'Vēlaties kandidēt valdes locekļa amatā?',
    boardSubtitle:
      'Business Club France–Latvia aicina iesaistīties motivētus kandidātus, kuri vēlas pievienoties tā valdei. Iesniedziet savu interesi, izmantojot zemāk redzamo formu.',
    members: [
      { id: 'william', name: 'William Le Clere', role: 'Loģistika', email: 'william@bcfl.eu' },
      { id: 'eric', name: 'Eric Brisset', role: 'Investors / Tehnoloģijas', email: 'eric@bcfl.eu' },
      { id: 'inese', name: 'Inese Treiliņa-Bergmane', role: 'Nekustamais īpašums', email: 'inese@bcfl.eu' },
      { id: 'guna', name: 'Guna Zagorska', role: 'Banku pakalpojumi / Finanses / Izglītība', email: 'guna.zagorska@bcfl.eu' },
    ],
  },
};

// Official portraits of the team members.
// `objectPosition` fine-tunes the framing of the face within the card crop.
export const memberPortraits = {
  william: {
    src: 'https://customer-assets.emergentagent.com/job_09571151-f654-4506-aa32-05da61a50408/artifacts/td3k9g3e_William%20Le%20Clere%20-%20Couleur.webp',
    objectPosition: 'center 22%',
  },
  eric: {
    src: 'https://customer-assets.emergentagent.com/job_09571151-f654-4506-aa32-05da61a50408/artifacts/epkn9ttm_Eric-Brisset%20-%20Copy.png',
    objectPosition: 'center 30%',
  },
  inese: {
    src: 'https://customer-assets.emergentagent.com/job_09571151-f654-4506-aa32-05da61a50408/artifacts/ll83j7od_Inese%20-%20Copy.jpg',
    objectPosition: 'center 30%',
  },
  guna: {
    src: 'https://customer-assets.emergentagent.com/job_09571151-f654-4506-aa32-05da61a50408/artifacts/y2uuu7ul_Guna_Zagorska%20-%20Copy.jpg',
    objectPosition: 'center 25%',
  },
};

export default teamContent;
